import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import './components/Common/ToolBarSearch.scss';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import App from 'App';
import { getAppInsights, reactPlugin } from './ApplicationInsights';
import AuthProvider, { AuthProviderVariables } from './AuthProvider';
import { unregister } from './registerServiceWorker';
import configureStore from './store/configureStore';
import { createRoot } from 'react-dom/client';
import auth from './Auth';
import { configurationService } from 'subjects/crossModules/ConfigurationService';
import { map } from 'rxjs';

const LOCALSTORAGE_RECORD_SERVER_TIMING_KEY = 'recordServerTiming';
const sessionRecord = localStorage.getItem(LOCALSTORAGE_RECORD_SERVER_TIMING_KEY);
let record = sessionRecord === 'true';

const subscription = configurationService.getAminFlags$().pipe(
  map((response) => {
    const applications = response.response;
    const flags = applications.find((app) => app.name?.toLowerCase() === 'ava')?.featureFlags;

    if (!flags) {
      return false;
    }

    return flags.find((flag) => flag.name?.toLowerCase() === 'recordservertiming')?.isActive;
  })
).subscribe((value) => {
  subscription.unsubscribe();
  record = value;
  localStorage.setItem(LOCALSTORAGE_RECORD_SERVER_TIMING_KEY, Boolean(value).toString());
});


(function () {
  // Save a reference to the original open and send methods
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, async, user, password) {
    this._url = url;
    originalOpen.call(this, method, url, async ?? true, user, password);
  } as unknown as typeof XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.send = function (body) {
    const xhr = this;
    if (xhr._url.includes('api/') && record) {
      this.addEventListener('readystatechange', function () {
        if (xhr.readyState === 4) {
          const entries = performance.getEntriesByType('resource').filter(entry => entry.name === xhr.responseURL);
          if (entries.length) {
            const entry = entries[0] as PerformanceResourceTiming;
            getAppInsights().trackEvent({
              name: 'UIResourceTiming', properties: {
                url: xhr._url,
                duration: entry.duration,
                startTime: entry.startTime,
                user: auth.currentUser()?.emails[0],
                dnsLookupTime: entry.domainLookupEnd - entry.domainLookupStart,
                tcpConnectTime: entry.connectEnd - entry.connectStart,
                responseTime: entry.responseEnd - entry.responseStart,
                serverWaitTime: entry.responseStart - entry.requestStart,
                serverTiming: xhr.getResponseHeader('Server-Timing'),
                appInsightsCorrelationId: xhr.getResponseHeader('X-Request-Id'),
              }
            });
          }
        }
      });
    }
    originalSend.call(this, body);
  };
})();



// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl } as any);

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState;
const store = configureStore(history, initialState);

const container = document.getElementById('root');
const root = createRoot(container!);

const getUrlVars = () => {
  const vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value): any {
    vars[key] = value;
  });
  return vars;
};
const urlAccessToken = getUrlVars()['cc_access_token'];

const renderContent = () => {
  return (
    <Provider store={store}>
      <ReduxRouter history={history} store={store}>
        <AppInsightsErrorBoundary onError={() => <h1>something went wrong</h1>} appInsights={reactPlugin}>
          <App />
        </AppInsightsErrorBoundary>
      </ReduxRouter>
    </Provider>
  );
};

if (urlAccessToken) {
  const appInsights = getAppInsights();
  appInsights.trackEvent({ name: 'AVA-Member-UI-Login-UrlAccessToken' });
  sessionStorage.setItem(AuthProviderVariables.CC_ACCESS_TOKEN, urlAccessToken);
  root.render(renderContent());
  unregister();
} else {
  root.render(<AuthProvider>{renderContent()}</AuthProvider>);
  unregister();
}
